// src/pages/support/components/AddFinalistModal.jsx
import React, { useState } from "react";

function AddFinalistModal({ teams, finalists, onSubmit }) {
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRole, setSelectedRole] = useState("member");
  const [searchQuery, setSearchQuery] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const filteredFinalists = finalists.filter((finalist) => {
    const search = searchQuery.toLowerCase();
    const fullName = `${finalist.first_name} ${finalist.last_name}`.toLowerCase();
    const email = (finalist.email || "").toLowerCase();
    const username = (finalist.username || "").toLowerCase();
    
    return (
      fullName.includes(search) ||
      email.includes(search) ||
      username.includes(search) ||
      String(finalist.user_id).includes(search)
    );
  });

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!selectedTeam) {
      setError("لطفا یک تیم انتخاب کنید");
      return;
    }
    
    if (!selectedUser) {
      setError("لطفا یک فینالیست انتخاب کنید");
      return;
    }

    setError("");
    setSubmitting(true);

    await onSubmit(
      {
        teamId: selectedTeam,
        userId: parseInt(selectedUser),
        role: selectedRole,
      },
      () => {
        setSubmitting(false);
      },
      (err) => {
        setError(err);
        setSubmitting(false);
      }
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Team Selection */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          انتخاب تیم
        </label>
        <select
          value={selectedTeam}
          onChange={(e) => setSelectedTeam(e.target.value)}
          className="w-full px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 text-gray-200 focus:outline-none focus:border-emerald-500"
          required
        >
          <option value="">-- انتخاب کنید --</option>
          {teams.map((team) => (
            <option key={team.id} value={team.id}>
              {team.name}
            </option>
          ))}
        </select>
      </div>

      {/* Role Selection */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          نقش
        </label>
        <select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          className="w-full px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 text-gray-200 focus:outline-none focus:border-emerald-500"
          required
        >
          <option value="member">عضو (Member)</option>
          <option value="captain">کاپیتان (Captain)</option>
        </select>
      </div>

      {/* Search Box */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          جستجوی فینالیست
        </label>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="جستجو بر اساس نام، ایمیل یا user_id..."
          className="w-full px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 text-gray-200 focus:outline-none focus:border-emerald-500"
        />
      </div>

      {/* Finalists List */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          انتخاب فینالیست ({filteredFinalists.length} نفر)
        </label>
        <div className="max-h-96 overflow-y-auto border border-gray-700 rounded-lg bg-gray-800">
          {filteredFinalists.length === 0 ? (
            <div className="p-4 text-center text-gray-400">
              فینالیستی یافت نشد
            </div>
          ) : (
            <div className="divide-y divide-gray-700">
              {filteredFinalists.map((finalist) => (
                <label
                  key={finalist.user_id}
                  className={`flex items-center p-3 cursor-pointer hover:bg-gray-700 transition-colors ${
                    selectedUser === String(finalist.user_id)
                      ? "bg-gray-700"
                      : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="finalist"
                    value={finalist.user_id}
                    checked={selectedUser === String(finalist.user_id)}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    className="ml-3 w-4 h-4 text-emerald-500"
                  />
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <span className="text-white font-medium">
                        {finalist.first_name} {finalist.last_name}
                      </span>
                      <span className="text-xs text-gray-400">
                        رتبه: {finalist.rank}
                      </span>
                    </div>
                    <div className="text-xs text-gray-400 mt-1">
                      User ID: {finalist.user_id} | {finalist.email}
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      امتیاز: {finalist.points} | موجودی: {finalist.balance}
                    </div>
                  </div>
                </label>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="p-3 bg-red-500/10 border border-red-500/50 rounded-lg text-red-400 text-sm">
          {error}
        </div>
      )}

      {/* Buttons */}
      <div className="flex gap-3 pt-4">
        <button
          type="submit"
          disabled={submitting || !selectedTeam || !selectedUser}
          className="flex-1 px-4 py-2 rounded-lg bg-emerald-500 text-white font-medium hover:bg-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {submitting ? "در حال افزودن..." : "افزودن به تیم"}
        </button>
      </div>
    </form>
  );
}

export default AddFinalistModal;